import axios from 'axios';
import { SUCCESSFUL_REQUEST_CODE, BASE_URL } from '../../utils';

export const loginActivate = async (user, token, action) => {
	try {
		const res = await axios.get(
			`${BASE_URL}/api/login-tracker?username=${user}&action=${action}`,
			{
				headers: {
					'Content-Type': 'application/json',
					authorization: `Bearer ${token}`
				}
			}
		);

		if (SUCCESSFUL_REQUEST_CODE.includes(res.status)) {
			return res.data;
		} else {
			return {
				isActive: false
			};
		}
	} catch (error) {
		console.error(error);
	}
};
